<template>
  <div class="info-hearing-aid">
    <HeroBanner
        :background-image="bannerImage"
        title="보청기 정보"
        sub-title="보청기 종류와 최신 기술, <br>
        올바른 사용법까지 알기 쉽게 알려드립니다."
    />
    <BoardList
      :boards="boards"
      :loading="loading"
      detail-path="/information/hearing-aid"
      :show-search="true"
      :show-more-button="hasMore"
      @search="handleSearch"
      @load-more="loadMoreBoards"
    />
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import BoardList from "@/components/BoardList.vue";
import boardListMixin from '@/mixins/boardListMixin';
import { fetchHearingAidInfoList } from '@/api';
import bannerBg from '@/assets/images/heros/05-top-img.png';
import bannerBg2 from '@/assets/images/heros/05-top-img@2x.png';

export default {
  name: 'InfoHearingAid',
  components: {HeroBanner, BoardList},
  mixins: [boardListMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
      boardPath: '/information/hearing-aid'
    };
  },
  methods: {
    fetchAPI(params) {
      return fetchHearingAidInfoList(params);
    }
  }
};
</script>

<style scoped lang="scss">
.info-hearing-aid {
  width: 100%;
  min-height: 55px;
}
</style>
